<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      title="提取数据"
      id-key="ClassId"
      :data="data"
      :line-form="true"
      form-label-width="100px"
      :form-rules="rules"
      :save-func="() => {}"
      @opened="onOpened"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <template v-if="is_Status === 0">
          <el-form-item label="存货编码">
            <el-input v-model="data.ProductNo" placeholder="请输入存货编码" />
          </el-form-item>
          <el-form-item label="存货名称">
            <el-input v-model="data.ProductName" placeholder="请输入存货名称" />
          </el-form-item>
        </template>
        <template v-if="is_Status === 1">
          <el-form-item label="客户分类编码">
            <el-input v-model="data.ClassNo" placeholder="请输入客户分类编码" />
          </el-form-item>
          <el-form-item label="客户分类名称">
            <el-input
              v-model="data.ClassName"
              placeholder="请输入客户分类名称"
            />
          </el-form-item>
        </template>
      </template>
      <template #footer>
        <el-button type="primary" @click="toSave">查 询</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        ProductNo: "",
        ProductName: "",
        ClassNo: "",
        ClassName: "",
      },
      is_Status: 0,
      formApi: require("@/api/sy/formSetting").default,
      api: require("@/api/sa/discountPriceCustomerType").default,
      // trendData: iForm.Data,
      showList: [],
      rules: {
        ProductNo: [{ required: true, message: "请输入分类编码" }],
        ProductName: [{ required: true, message: "请输入分类名称" }],
        Sn: [{ required: true, message: "请输入序号" }],
      },
    };
  },
  methods: {
    // 打开时获取显示显示列表
    onOpened(data) {
      console.log("data", data);
      this.is_Status = data;
    },

    onEditOpened(data) {},
    toSave() {
      this.$refs.dialog.formValidate().then((valid) => {
        if (!valid) return;
        //移除 null 与 "" 的值
        var data = this.$commonJs.obj.removeNullKey(this.data);
        this.api.productList(data).then((res) => {
          this.$refs.dialog.isLoading = false;
          if (res.Code == 0) {
            if( res.Data.length == 0) return this.$message.warning("未提取到数据");
            let tableList = res.Data?.reduce((acc, item) => {
              acc.push({
                DiscountPriceCustomerTypeId: 0,
                ...item,
                // ProductId: 0,
                // DiscountRate: 0,
                // TradeUnitType: 0,
                // FinalPrice: 0,
                // UpdateEmpId: 0,
                // UpdateDate: "",
                // AddUserId: 0,
                // AddTime: "",
                // Remark: "",

                // GoodsPriceId: 0,
                // ProductId: item.ProductId,
                // RetailPrice: 0,
                // TradePrice: 0,
                UpdateEmpId: this.$commonJs.empId(),
                UpdateDate: this.$commonJs.getToday(),
                AddUserId: this.$commonJs.userId(),
                AddTime: this.$commonJs.getToday(),
              });
              return acc;
            }, []);
            console.log("tableList", tableList);
            if (tableList.length > 0) {
              return this.$confirm("提取到"+tableList.length+"条记录，是否确定保存", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {
                var loading = this.$loading({
                  lock: true,
                  text: "正在保存...",
                  spinner: "el-icon-loading",
                  customClass: "my_loading",
                  background: "rgba(0, 0, 0, 0.3)",
                });
                this.api.save(tableList).then((result) => {
                  if (res.Code === 0) {
                    this.$parent.findList();
                    this.$message.success(result.Msg);
                    // this.$emit("close-saved");
                    this.close(true);
                  } else this.$message.error(result.Msg);
                  loading.close();
                });
              });
            }

           
          } else {
            this.$message.error(res.Msg);
          }
        });
        // this.$parent.onExport(data);
        //this.$parent.findList(data);
        this.$emit("close-saved");
        this.close(true);
        // this.$refs.dialog.isLoading = true;
        // this.api.save(data).then((res) => {
        //   this.$refs.dialog.isLoading = false;
        //   if (res.Code == 0) {
        //     this.$message.success(res.Msg);
        //     this.$emit("close-saved");
        //     this.close(true);
        //   } else {
        //     this.$message.error(res.Msg);
        //   }
        // });
      });
    },
    onClosed() {
      this.showList = [];
    },
  },
};
</script>
